/* Shopify Ajax Cart API: update discounts without submitting or changing quantities. */
(() => {
  const storageKey = 'deidou-discount-result-v1';
  const normalized = code => String(code || '').trim().toLocaleLowerCase();
  function applications(cart) {
    return [...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))]
      .filter(Boolean);
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-discount-form]').forEach(form => {
      if (form.dataset.discountReady) return;
      form.dataset.discountReady = '1';
      const input = form.querySelector('[name=discount]');
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('[data-discount-status]');
      const cartLink = form.querySelector('[data-discount-cart]');
      const root = form.dataset.root.replace(/\/?$/, '/');
      function message(key, state = '') {
        status.textContent = form.dataset[key]; status.dataset.state = state;
        input.setAttribute('aria-invalid', String(key === 'invalid'));
      }
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (saved && Date.now() - saved.time < 60000 && location.pathname === form.dataset.cart) {
          input.value = saved.code; message(saved.key, saved.state);
          sessionStorage.removeItem(storageKey);
        }
      } catch (_) { /* Storage may be disabled. Inline feedback still works. */ }
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (document.documentElement.dataset.preview || button.disabled) return;
        const code = input.value.trim();
        if (!code) { input.focus(); return; }
        button.disabled = true; form.setAttribute('aria-busy', 'true');
        message('checking'); cartLink.hidden = true;
        async function request(url, options) {
          const response = await fetch(url, { credentials:'same-origin', ...options });
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        }
        try {
          const current = await request(root + 'cart.js');
          if (!current.item_count) { message('empty', 'error'); return; }
          const existing = [ ...(current.discount_codes || []).map(d => d.code),
            ...applications(current).filter(a => a.type === 'discount_code').map(a => a.title) ];
          const codes = [...new Map([...existing, code].filter(Boolean).map(c => [normalized(c), c])).values()];
          const cart = await request(root + 'cart/update.js', {
            method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
            body:JSON.stringify({discount:codes.join(',')})
          });
          const result = (cart.discount_codes || []).find(d => normalized(d.code) === normalized(code));
          const allocated = applications(cart).some(a => a.type === 'discount_code' && normalized(a.title) === normalized(code));
          const key = result?.applicable === true || allocated ? 'applied' : result?.applicable === false ? 'invalid' : 'pending';
          const state = key === 'applied' ? 'success' : key === 'invalid' ? 'error' : '';
          message(key, state); cartLink.hidden = location.pathname === form.dataset.cart;
          // Refresh native cart markup if discounts changed prices or item keys.
          if (location.pathname === form.dataset.cart &&
              (cart.total_price !== current.total_price || JSON.stringify(cart.items) !== JSON.stringify(current.items))) {
            try { sessionStorage.setItem(storageKey, JSON.stringify({code,key,state,time:Date.now()})); } catch (_) {}
            location.reload();
          }
        } catch (_) { message('error', 'error'); }
        finally { button.disabled = false; form.removeAttribute('aria-busy'); }
      });
    });
  }
  init(); document.addEventListener('shopify:section:load', () => init());
})();
